module.exports = "/assets/2n4FQBrpdq.png";